<template>
    <div name="fade" class="vod-certificate-payment">
        <ListPlaceholder
            v-if="!initLoading && error"
            :title="$t('LABEL_TIMEOUT_TITLE')"
            :subtitle="$t('LABEL_TIMEOUT_SUBTITLE')"
        />
        <ListPlaceholder
            :title="'Oczekiwanie na pośrednika płatności'"
            :subtitle="'Może to potrwać do kilku minut'"
            v-if="initLoading && isTransactionPending"
        />
        <ListLoader v-if="initLoading" />
        <div
            v-if="!initLoading"
            style="height: 100%; display: flex; flex-direction: column"
        >
            <div class="vod-certificate-content">
                <VodCertificatePaymentContent
                    :webinar="webinar"
                    v-if="contentType == 'webinar'"
                />
                <VodConferencePaymentContent
                    :conference="conference"
                    v-if="contentType == 'conference' && !conferenceWebinar"
                />
                <VodLivestreamPaymentContent
                    :conference="conference"
                    :webinar="webinar"
                    v-if="contentType == 'livestream' || conferenceWebinar"
                    @itemSelected="itemSelected"
                />
            </div>
            <div class="vod-summary-row" v-if="contentType != 'livestream'">
                <p>Wartość produktu:</p>
                <div style="display: flex;">
                    <b
                        ><p class="crossed-price">
                            {{ crossedPrice }}
                        </p></b
                    >
                    <b
                        ><p>{{ sumPrice }}</p></b
                    >
                </div>
            </div>
            <div v-if="!userLogged">
                <transition name="fade" mode="out-in">
                    <div
                        v-if="!loginVisible && !registerVisible"
                        style="
                            display: flex;
                            justify-content: center;
                            margin: 2rem 0;
                        "
                    >
                        <div class="vod-button" @click="showLogin">
                            Mam konto w Livekid
                        </div>
                        <div @click="showRegister" class="vod-button -border">
                            Utwórz nowe konto
                        </div>
                    </div>
                    <div
                        class="vod-forms"
                        v-if="loginVisible || registerVisible"
                    >
                        <VodLoginForm
                            @register="toggleRegister"
                            @close="loginVisible = false"
                            v-if="loginVisible"
                        />
                        <VodRegisterForm
                            @close="registerVisible = false"
                            @registered="userRegistered"
                            v-if="registerVisible"
                        />
                    </div>
                </transition>
            </div>
            <div v-if="userLogged">
                <div class="vod-summary-legals">
                    <div style="margin-right: 1rem;">
                        <a
                            href="https://livekid.com/wp-content/uploads/dokumenty/LiveKid-regulamin-dla-p%C5%82atnika.pdf"
                            target="_blank"
                            ><b>{{ $t('TRANSACTION_LEGALS_LINK') }}</b></a
                        >
                        <div>{{ $t('TRANSACTION_LEGALS') }}</div>
                    </div>
                    <CheckBox color="apple" v-model="ruleAccepted" />
                </div>
                <PromoCode
                    :selectedItem="selectedItem"
                    @update="getDiscount"
                    v-if="!currentPromoCode"
                />
                <div class="vod-payment-summary">
                    <div class="payment-summary-desc">
                        <div v-if="!isMobile" class="payment-summary-label">
                            Razem
                        </div>
                        <div v-else>Do zapłaty</div>
                        <div class="payment-summary-value">
                            {{ sumPrice }}
                        </div>
                    </div>
                    <ActionButton
                        v-if="!isMobile"
                        :color="buttonColor"
                        :label="'Przejdź do płatności'"
                        @click="createBill"
                        :loading="loading"
                    />
                    <Button
                        v-else
                        title="Przejdź do płatności"
                        :disabled="!ruleAccepted"
                        :loading="loading"
                        @click="createBill"
                    />
                </div>
            </div>
            <transition name="fade">
                <BlueMediaModal
                    :vod="true"
                    :transactionData="transactionData"
                    @close="closePaymentModal"
                    v-if="blueMediaVisible"
                />
            </transition>
        </div>
    </div>
</template>
<script>
export default {
    components: {
        PromoCode: () => import('./PromoCode'),
        VodLoginForm: () => import('./VodLoginForm'),
        VodRegisterForm: () => import('./VodRegisterForm'),
        BlueMediaModal: () =>
            import('../../components/payments/BlueMediaModal'),
        VodCertificatePaymentContent: () =>
            import('./VodCertificatePaymentContent'),
        VodConferencePaymentContent: () =>
            import('./VodConferencePaymentContent'),
        VodLivestreamPaymentContent: () =>
            import('./VodLivestreamPaymentContent')
    },
    props: {
        webinar: Object,
        conferenceWebinar: Object
    },
    data() {
        return {
            initLoading: true,
            loading: false,
            loginVisible: false,
            registerVisible: false,
            ruleAccepted: false,
            blueMediaVisible: false,
            error: false,
            transactionData: {},
            pendingBills: [],
            isTransactionPending: false,
            selectedItem: {},
            discount: 0
        }
    },
    computed: {
        currentPromoCode() {
            const product = this.webinar.uuid
            const currentPromoCodes = this.$store.state.currentPromoCodes
            return currentPromoCodes[product]
        },
        conference() {
            return (
                this.conferenceWebinar ||
                (this.webinar.type == 'vod-conference' && this.webinar) ||
                this.$store.getters['content/conferenceByWebinar'](
                    this.webinar.uuid
                )
            )
        },
        contentType() {
            switch (true) {
                case this.conference &&
                    this.conference.uuid != undefined &&
                    this.webinar.livestream_url &&
                    this.webinar.livestream_url != '':
                    return 'livestream'
                case this.conference && this.conference.uuid != undefined:
                    return 'conference'
                default:
                    return 'webinar'
            }
        },
        buttonColor() {
            return this.ruleAccepted ? 'apple' : 'grey'
        },
        crossedPrice() {
            if (!this.webinar.conference) {
                return this.webinar.old_cost
                    ? this.$Utils.getBackendPrice(this.webinar.old_cost, this)
                    : ''
            }
        },
        productCost() {
            const cost = this.selectedItem.cost
                ? this.selectedItem.cost
                : this.conference && this.conference.cost
                ? this.conference.cost
                : this.webinar.cost
            return this.discount
                ? this.$Utils.floorNumber(
                      ((cost + 199) * (100 - this.discount)) / 100
                  ) - 199
                : cost
        },
        sumPrice() {
            return this.$Utils.getBackendPrice(this.productCost + 199, this)
        },
        userLogged() {
            return this.$store.state.user.account_id != undefined
        },
        isMobile() {
            return this.$store.getters['source/isMobile']
        }
    },
    methods: {
        getDiscount() {
            const product = this.selectedItem.uuid || this.$route.params.uuid
            this.discount = this.$store.state.currentPromoCodes[product]
                ? this.$store.state.currentPromoCodes[product].discount
                : 0
        },
        itemSelected(item) {
            this.selectedItem = item
        },
        showLogin() {
            this.loginVisible = true
            this.$emit('scroll')
        },
        showRegister() {
            this.registerVisible = true
            this.$emit('scroll')
        },
        async checkIfTransactionPending() {
            return new Promise((resolve, reject) => {
                const billIndex = this.getExisitingBill()
                if (billIndex == -1) {
                    resolve(false)
                    return
                }
                this.$api
                    .get('v1/check/time')
                    .then(({ data }) => {
                        const time = data
                        const existingBill = this.pendingBills[billIndex]
                        const isPending = existingBill.payments.some(
                            p => p.status == 'pending' && time - p.date < 300000
                        )
                        resolve(isPending)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        closePaymentModal() {
            this.checkBillStatus()
            this.blueMediaVisible = false
        },
        savePositionToStore() {
            const commit =
                this.webinar.type == 'vod-course'
                    ? 'setPendingTransactionCourse'
                    : 'setPendingTransactionWebinar'
            this.$store.commit(commit, this.webinar.uuid)
        },
        userRegistered() {
            this.registerVisible = false
            this.savePositionToStore()
        },
        getPayways(bill) {
            this.$api
                .post(this.$Network.provideURL(`v1/payments/ways`), {
                    bills: [bill.id]
                })
                .then(({ data }) => {
                    this.transactionData = {
                        transaction: data.transaction,
                        gateways: data.gateways,
                        bills: [bill]
                    }
                    this.blueMediaVisible = true
                    this.savePositionToStore()
                })
                .catch(error => {
                    this.$Network.handleError(error)
                })
                .then(() => {
                    this.loading = false
                })
        },
        async checkBillStatus() {
            if (!this.$store.state.user.account_id) {
                this.initLoading = false
                return
            }
            await this.getBills()
            this.isTransactionPending = await this.checkIfTransactionPending()
            if (this.isTransactionPending) {
                setTimeout(() => {
                    this.checkBillStatus()
                }, 15000)
            } else {
                this.getBoughtItems()
            }
        },
        getBills() {
            return this.$api
                .get(`v1/marketplace/bills`)
                .then(({ data }) => {
                    this.pendingBills = data
                })
                .catch(error => {
                    this.$Network.handleError(error)
                    this.error = true
                    this.initLoading = false
                })
        },
        getBoughtItems() {
            this.$api
                .get(`v1/marketplace/items`)
                .then(({ data }) => {
                    this.$store.commit('setBoughtItems', data)
                })
                .catch(error => {
                    this.error = true
                    this.$Network.handleError(error)
                })
                .then(() => {
                    this.initLoading = false
                })
        },
        getExisitingBill() {
            return this.pendingBills.findIndex(
                bill =>
                    bill.uuid == this.webinar.uuid ||
                    bill.uuid == this.webinar.conference
            )
        },
        createBill() {
            if (this.loading) {
                return
            }
            if (!this.ruleAccepted) {
                this.$Notif.error('', 'Zaakceptuj regulamin')
                return
            }
            this.loading = true
            const existingBillIndex = this.getExisitingBill()
            if (existingBillIndex != -1) {
                this.getPayways(this.pendingBills[existingBillIndex])
                return
            }
            const user = this.$store.state.user
            let cost = this.productCost
            const uuid = this.selectedItem.uuid
                ? this.selectedItem.uuid
                : this.webinar.conference
                ? this.webinar.conference
                : this.webinar.uuid
            if (user.mail == 'piotr.pulchny+vod12345@livekid.com') {
                cost = 100
            }
            // TODO: REMOVE THAT
            const data = {
                title: this.getPaymentTitle(),
                amount: cost >= 0 ? cost : 1,
                uuid: uuid
            }
            this.$api
                .post(`v1/marketplace`, data)
                .then(({ data }) => {
                    this.getPayways(data)
                })
                .catch(error => {
                    this.loading = false
                    this.$Network.handleError(error)
                })
        },
        getPaymentTitle() {
            let uuid
            switch (true) {
                case this.selectedItem.uuid != undefined:
                    uuid = this.selectedItem.uuid
                    break
                case this.webinar.conference != undefined:
                    const conference = this.$store.getters[
                        'content/conferenceByWebinar'
                    ](this.webinar.uuid)
                    uuid = conference ? conference.uuid : this.webinar.uuid
                    break
                default:
                    uuid = this.webinar.uuid
                    break
            }
            const { name } = this.$store.state.user
            return `${name} ${uuid}`
        },
        toggleRegister() {
            this.loginVisible = false
            this.registerVisible = true
        }
    },
    mounted() {
        this.checkBillStatus()
        this.getDiscount()
    }
}
</script>
<style lang="scss" scoped>
.vod-certificate-payment {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.vod-certificate-content {
    max-height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}
.vod-button {
    margin-left: 1rem;
    cursor: pointer;
    padding: 0.4rem 1rem;
    transition: $ease;
    position: relative;
    font-family: $input-family;

    &:hover {
        transform: translateY(0.1rem);
    }

    &.-border {
        border: solid 1px $accent-apple;
        border-radius: $minimal-radius;

        &:hover {
            background: $accent-apple;
            transform: none;
        }
    }
}
.vod-forms {
    padding: 1rem 5rem;
}
.vod-payment-summary {
    border-top: 1px solid #fff;
    margin: 1rem -1rem -1rem -1rem;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
}
.payment-summary-label {
    font-size: 1.2rem;
    letter-spacing: 0.15rem;
}
.payment-summary-value {
    margin-top: 0.2rem;
    font-size: 1.8rem;
    font-family: $input-family;
    white-space: nowrap;
}
.vod-summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    font-size: 1.2rem;

    b {
        white-space: nowrap;
    }

    p {
        margin: 0;
    }
}
.vod-summary-legals {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.5rem;

    div {
        margin-top: 0.2rem;
    }

    a {
        color: var(--color);
        margin-bottom: 0.5rem;
    }
}
.crossed-price {
    text-decoration: line-through;
    color: $accent-grey;
    padding-right: 0.5rem;
}
@media (max-width: 1000px) {
    .vod-forms {
        padding: 1rem;
    }
    .vod-payment-summary {
        display: block;
    }
    .payment-summary-desc {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: $smoked;
        font-family: $input-family;

        .payment-summary-value {
            margin-top: 0;
            font-size: 14px;
        }
    }
}
.vod-summary-legals {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.75rem;

    div {
        margin-top: 0.2rem;
        font-size: 9px;
    }

    a {
        color: var(--color);
        margin-bottom: 0.5rem;
    }
}
</style>
